'use strict';

var EditLan = require('actionGroups/editLan/EditLan');
var EditLanView = require('actionGroups/editLan/EditLanView');

module.exports = {
  Model: EditLan,
  GroupView: EditLanView,
};
